import $ from "jquery";
import { reparseUnobtrusiveValidation } from "../utils/validation.js";

var onPageUpdated;

function cloneAdderInputs(forString, newKey = null, previousInputs = null) {
    var adderInputs = $(`[name="${forString}_InputsTemplate"]`).clone();
    adderInputs.find(':input').removeAttr("disabled");
    adderInputs.attr("name", "adderInputs");

    var keyType = adderInputs.attr("data-val-key-type");
    if (!newKey) {
        if (keyType == "Guid") {
            newKey = crypto.randomUUID();
        }

        if (keyType == "Int32") {
            var usedKeyCount = $(`[data-val-for="${forString}"]:not([name*="Template"])`).length;
            newKey = usedKeyCount;
        }
    }

    adderInputs.attr("data-val-key", newKey);
    if (newKey) {
        updateAdderKeyIn(adderInputs, newKey, "PLACEHOLDER_KEY");
    }

    adderInputs.find(':input').val('');
    var dictionaryKeySelect = adderInputs.find('select[dictionary-key="dictionary-key"]');
    if (dictionaryKeySelect.length > 0) {
        enforceSelectKeyUniqueness(adderInputs);
        dictionaryKeySelect.on('change', onDictionaryKeyChange);
    }

    var maxGroupCount = adderInputs.attr('data-val-max-group-count');
    if (maxGroupCount) {
        enforceSelectGroupSize(adderInputs, maxGroupCount);
    }

    var addFromTop = adderInputs.attr('data-val-add-from-top');

    if (addFromTop == "False") {
        $("#" + forString + "_Inputs").before(adderInputs);
    }
    else {
        $("#" + forString + "_Inputs").after(adderInputs);
    }

    var cardsEnabled = $("#" + forString + "_Inputs").attr('data-summary-cards-enabled');

    if (cardsEnabled != "False") {
        $('[name="AddButton"]').attr("disabled", "disabled");
        $('[name="SummaryCardsEditButton"').attr("disabled", "disabled");
    }

    reparseUnobtrusiveValidation();

    if (previousInputs) {
        previousInputs.each(function () {
            var name = $(this).attr("name");
            adderInputs.find(`:input[name="${name}"]`).val($(this).val());
        })
    }

    adderInputs.css("display", "none");

     if (previousInputs || cardsEnabled == "False") {
        adderInputs.slideDown();
     }
     else {
         $(`#${forString}`).closest('[name="DictionaryAddButtonRow"]').slideUp(function () {
             adderInputs.slideDown();
         });
     }

    return adderInputs;
}

function adderConfirm() {
    var adderInputs = $(this).closest('[name="adderInputs"]');
    if (!adderInputs.find(":input").valid()) {
        return;
    }

    var newKey = adderInputs.attr("data-val-key");
    var keyInput = adderInputs.find(':input[dictionary-key="dictionary-key"]');
    if (keyInput.length > 0) {
        newKey = keyInput.val();
    }

    var forString = adderInputs.attr("data-val-for");
    var cardsEnabled = $("#" + forString + "_Inputs").attr('data-summary-cards-enabled');
    if (cardsEnabled == "False") {
        adderInputs.removeClass("adderInputs");
        adderInputs.children('[name="InlineDeleteButton"]').removeClass('d-none');
        $(this).closest('[name="ConfirmDeleteControls"]').siblings('[name="AdderLabel"]').slideUp();
        $(this).closest('[name="ConfirmDeleteControls"]').slideUp(function () {
            if (!dictionaryFull(adderInputs)) {
                $(`#${forString}`).closest('[name="DictionaryAddButtonRow"]').slideDown();
                $('[name="AddButton"]').removeAttr("disabled");
                $('[name="SummaryCardsEditButton"]').removeAttr("disabled");
            }
            adderInputs.addClass("inlineDeleteButtonWrapper");
        });
        return;
    }

    var cardTemplate = $(`[name="${forString}_CardTemplate"]`).clone();

    cardTemplate.find(':input').removeAttr("disabled");
    cardTemplate.removeClass("d-none");
    cardTemplate.attr("name", newKey);
    cardTemplate.css("display", "none");
    updateAdderKeyIn(cardTemplate, newKey, "PLACEHOLDER_KEY");

    $(this).closest('[name="adderInputs"]').find(":input").each(function () {
        var name = $(this).attr("name");
        cardTemplate.find(`input[name="${name}"]`).val($(this).val());
    });

    cardTemplate.find('.card-body').find('p').each(function () {
        var name = $(this).attr("name");

        var content = "";
        if ($(this).attr("data-val-title-properties")) {
            var titlePropsContent = [];
            JSON.parse($(this).attr("data-val-title-properties")).forEach(function (property) {
                titlePropsContent.push(getInputTextContent(adderInputs, property));
            });
            content = titlePropsContent.join(" ");
        }
        else {
            content = getInputTextContent(adderInputs, name)
        }

        $(this).text(content);
    });

    
    adderInputs.slideUp(function () {
        $(this).replaceWith(cardTemplate);
        cardTemplate.slideDown();
        if (!dictionaryFull(adderInputs)) {
            $(`#${forString}`).closest('[name="DictionaryAddButtonRow"]').slideDown();
        }
        $('[name="AddButton"]').removeAttr("disabled");
        $('[name="SummaryCardsEditButton"]').removeAttr("disabled");
        onPageUpdated();
    });   
}

function getInputTextContent(adderInputs, name) {
    var content = "";
    var input = adderInputs.find(`:input[name="${name}"]`);
    var preContent = input.prev(".input-group-text").text();
    var postContent = input.next(".input-group-text").text();
    if (input.is('input')) {
        content = input.val();
    }
    else if (input.is("select")) {
        content = input.find(":selected").text();
    }
    return `${preContent ?? ""}${content}${postContent ?? ""}`;
}

function onAddButtonClick(forString) {
    let adderInputs = cloneAdderInputs($(this).attr('id') || forString);
    onPageUpdated(adderInputs);
}

function adderDelete() {
    $('[name="AddButton"]').removeAttr("disabled");
    $('[name="SummaryCardsEditButton"]').removeAttr("disabled");
    
    $(this).closest('[name="adderInputs"]').slideUp(function () {
        $(this).nextAll('[name="DictionaryAddButtonRow"]').first().slideDown();
        $(this).remove();
        $(document).trigger('adderDeleted');
    });
}

function summaryCardDelete() {
    var id = $(this).attr('data-val-id');
    $(this).closest(`[name="${id}"]`).nextAll('[name="DictionaryAddButtonRow"]').first().slideDown();
    $(this).closest(`[name="${id}"]`).slideUp(function () {
        $(this).remove();
    })
}

function inlineDelete() {
    $(this).addClass("d-none");
    $(this).closest('[name="adderInputs"]').slideUp(function () {
        $(this).remove();
        $(document).trigger('adderDeleted');
    });
}

function summaryCardEdit() {
    var id = $(this).attr("data-val-id");
    var inputRow = $(this).closest(`[name="${id}"]`);
    var previousElement = inputRow.prev();

    $(`#${inputRow.attr("data-val-for")}`).closest('[name="DictionaryAddButtonRow"]').slideUp();
    inputRow.slideUp(function () {
        inputRow.detach();
        var forString = inputRow.attr("data-val-for");
        var previousInputs = inputRow.find(":input");
        var key = inputRow.attr("name");

        var adderInputs = cloneAdderInputs(forString, key, previousInputs);
        previousElement.after(adderInputs)
        onPageUpdated();
    });
}

function enforceSelectKeyUniqueness(adderInputs)
{
    var dataValFor = adderInputs.attr('data-val-for');
    var usedKeys = $(`[data-val-for="${dataValFor}"]:not([name*="Template"])`);
    var keySelectField = adderInputs.find('select[dictionary-key="dictionary-key"]');

    usedKeys.each(function () {
        var name = $(this).attr('name')
        keySelectField.find(`option[value="${name}"]`).remove();
    });
}

function enforceSelectGroupSize(adderInputs, maxGroupCount) {
    var dataValFor = adderInputs.attr('data-val-for');
    
    if (!maxGroupCount) {
        return;
    }

    var groupCounts = getGroupCounts(adderInputs, dataValFor);
    var filledGroups = [...groupCounts].filter(([_key, value]) => value >= maxGroupCount);

    var groupPropertyName = adderInputs.attr('data-val-group-property');
    var groupedSelectField = adderInputs.find(`select[name$="${groupPropertyName}"]`);
    filledGroups.forEach(function ([key, _value]) {
        groupedSelectField.find(`option[value="${key}"]`).remove();
    });
}

function dictionaryFull(adderInputs) {
    var dataValFor = adderInputs.attr('data-val-for');
    var maxCount = adderInputs.attr('data-val-max-count');
    var usedKeyCount = $(`[data-val-for="${dataValFor}"]:not([name*="Template"])`)
        .length;

    return usedKeyCount > 0 && (
        maxCountExceeded(maxCount, usedKeyCount) ||
        allGroupsFull(adderInputs, dataValFor) ||
        allKeysUsed(adderInputs, dataValFor, usedKeyCount));
}

function maxCountExceeded(maxCount, usedKeyCount) {
    return maxCount && usedKeyCount >= maxCount;
}

function allGroupsFull(adderInputs, dataValFor) {
    var maxGroupCount = adderInputs.attr('data-val-max-group-count');
    if (!maxGroupCount) {
        return false;
    }

    var groupCounts = getGroupCounts(adderInputs, dataValFor);
    return groupCounts.values().every(count => count >= maxGroupCount);
}

function getGroupCounts(adderInputs, dataValFor) {
    var groupCounts = new Map();
    JSON.parse(adderInputs.attr('data-val-group-types')).forEach(function (groupType) {
        groupCounts.set(groupType, 0);
    });
    var groupPropertyName = adderInputs.attr('data-val-group-property');
    $(`[data-val-for="${dataValFor}"]`).each(function () {
        if ($(this).attr('name').includes('Template')) {
            return;
        }

        var groupInputVal = $(this).find(`input[name$="${groupPropertyName}"]`).val();
        groupCounts.set(groupInputVal, groupCounts.get(groupInputVal) + 1);
    });

    return groupCounts;
}

function allKeysUsed(adderInputs, dataValFor, usedKeyCount) {
    if (adderInputs.find('select[dictionary-key="dictionary-key"]').length == 0) {
        return false;
    }

    var inputTemplate = $(`[data-val-for="${dataValFor}"][name="${dataValFor}_InputsTemplate"]`);
    var selectOptions = [];
    inputTemplate.find('select[dictionary-key="dictionary-key"]').find('option').each(function () {
        var value = $(this).val();
        if (value) {
            selectOptions.push(value)
        }
    });

    return selectOptions.length <= usedKeyCount;
}

function onDictionaryKeyChange() {
    var adderInputs = $(this).closest('[name="adderInputs"]');
    var newKey = $(this).val();
    var oldKey = $(this).attr('name').match(/\[([^\[\]]+)\]/)[1];
    updateAdderKeyIn(adderInputs, newKey, oldKey);
}

function updateAdderKeyIn(sourceElement, newKey, oldKey) {
    var attributes = ['name', 'id', 'data-testid', 'for', 'data-valmsg-for', 'data-val-title-properties', 'data-val-id'];
    sourceElement.find('*').each(function () {
        for (let attribute of attributes) {
            replaceStringInAttribute(this, attribute, oldKey, newKey);
        }
    });
}

function replaceStringInAttribute(element, attrName, oldVal, newVal) {
    if (element.attributes[attrName]) {
        element.attributes[attrName].value = element.attributes[attrName].value.replace(oldVal, newVal);
    }
}

function setupAdderInput(pageUpdateCallback) {
    onPageUpdated = pageUpdateCallback || function() {};
    $(document).on('click', '[name="AdderConfirmButton"]', adderConfirm)
        .on('click', '[name="AdderDeleteButton"]', adderDelete)
        .on('click', '[name="AddButton"]', onAddButtonClick)
        .on('click', '[name="SummaryCardsDeleteButton"]', summaryCardDelete)
        .on('click', '[name="SummaryCardsEditButton"]', summaryCardEdit)
        .on('click', '[name="InlineDeleteButton"]', inlineDelete);
}

export { setupAdderInput, inlineDelete, onAddButtonClick }